import api from './api';

const subscriptionService = {
  // Plans
  getPlans: () => api.get('/subscriptions/plans'),

  // Current subscription
  getCurrentSubscription: () => api.get('/subscriptions/current'),

  // Checkout
  createCheckoutSession: (data) => api.post('/subscriptions/checkout-session', data),

  // Customer Portal
  createPortalSession: () => api.post('/subscriptions/portal-session'),

  // Invoices
  getInvoices: (limit = 20) => api.get('/subscriptions/invoices', { params: { limit } }),

  // Helpers
  formatCurrency(amountCents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amountCents / 100);
  },

  formatDate(dateString) {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  },

  getTierColor(tier) {
    const colors = {
      '100': 'bg-yellow-100 text-yellow-800',
      '2000': 'bg-purple-100 text-purple-800',
    };
    return colors[tier] || 'bg-gray-100 text-gray-800';
  },

  getStatusColor(status) {
    const colors = {
      active: 'bg-green-100 text-green-800',
      trialing: 'bg-blue-100 text-blue-800',
      past_due: 'bg-red-100 text-red-800',
      canceled: 'bg-gray-100 text-gray-800',
      unpaid: 'bg-red-100 text-red-800',
      incomplete: 'bg-yellow-100 text-yellow-800',
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  },

  getStatusLabel(status) {
    const labels = {
      active: 'Active',
      trialing: 'Trial',
      past_due: 'Past Due',
      canceled: 'Canceled',
      unpaid: 'Unpaid',
      incomplete: 'Incomplete',
    };
    return labels[status] || status;
  },

  getInvoiceStatusColor(status) {
    const colors = {
      paid: 'bg-green-100 text-green-800',
      open: 'bg-yellow-100 text-yellow-800',
      draft: 'bg-gray-100 text-gray-800',
      uncollectible: 'bg-red-100 text-red-800',
      void: 'bg-gray-100 text-gray-500',
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  },
};

export default subscriptionService;
